module.exports = __webpack_public_path__ + "static/media/diva32.6c1d8b69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diva/diva32.jpg
// module id = 578
// module chunks = 0